<div class="space-y-3 pt-4">
  <div class="flex items-center gap-4">
    <button
      type="button"
      (click)="fileUploadClick()"
      [disabled]="isDisabled() || isLoading()"
      class="secondary-button small-button"
    >
      <mat-icon class="pt-0.5 text-sm">attach_file</mat-icon>
      {{ isLoading() ? 'Uploading…' : 'Upload a File' }}
    </button>

    <input
      type="file"
      #fileUploads
      id="fileUploads"
      name="fileUploads"
      class="hidden"
      (change)="onFileSelected($event)"
      [accept]="acceptedFileTypes"
    />
  </div>

  <!-- Helper text -->
  <p class="text-xs leading-relaxed text-gray-600">
    <span class="block">
      <strong>Allowed formats:</strong>
      PDF, Word (DOC, DOCX), Images (JPG, PNG, GIF, BMP).
    </span>
    <span class="block"> <strong>Maximum file size:</strong> 5&nbsp;MB. </span>
    <span class="block"> File names cannot contain special characters. </span>
  </p>

  <!-- File card -->
  @if (fileName()) {
    <div
      class="rounded-lg border px-4 py-3"
      [class.border-gray-200]="!hasError()"
      [class.bg-white]="!hasError()"
      [class.border-red-200]="hasError()"
      [class.bg-red-50]="hasError()"
      [class.opacity-90]="isLoading()"
    >
      <div class="flex items-start justify-between gap-4">
        <div class="flex items-start gap-3">
          <mat-icon
            class="mt-0.5"
            [class.text-gray-500]="!hasError()"
            [class.text-red-700]="hasError()"
          >
            description
          </mat-icon>

          <div class="min-w-0">
            <div
              class="truncate text-sm"
              [class.text-gray-900]="!hasError()"
              [class.text-red-700]="hasError()"
              title="{{ fileName() }}"
            >
              {{ fileName() }}
            </div>

            <!-- Status line -->
            <div class="mt-1 flex items-center gap-2 text-sm font-semibold">
              @if (isLoading()) {
                <mat-spinner diameter="14"></mat-spinner>
                <span class="text-gray-600">Uploading…</span>
              } @else if (hasError()) {
                <span class="text-red-700">Upload failed</span>
              } @else {
                <span class="text-gray-500">Ready to upload</span>
              }
            </div>
          </div>
        </div>

        <!-- Actions -->
        @if (!isLoading() && hasError()) {
          @if (!isLoading() && hasError()) {
            <div class="flex shrink-0 items-center gap-2">
              <button
                type="button"
                class="h-8 rounded-md border border-gray-300 bg-white px-3 text-xs text-gray-700 hover:bg-gray-50"
                (click)="fileUploadClick()"
              >
                Choose another file
              </button>

              <button
                type="button"
                class="flex h-8 w-8 items-center justify-center rounded-md border-none text-red-600 hover:bg-red-50 hover:text-red-700"
                (click)="clearSelectedFile()"
                aria-label="Remove selected file"
                title="Remove"
              >
                <mat-icon class="text-md">close</mat-icon>
              </button>
            </div>
          }
        }
      </div>

      @if (hasError()) {
        <div class="mt-3 flex gap-2 text-sm text-red-700">
          <mat-icon class="text-red-700">error</mat-icon>
          <div class="ml-1">
            <div>
              {{ fileUploadError() }}
            </div>
            <p class="text-xs text-red-700">
              Example: <span class="font-mono">2025-02-01_Invoice.pdf</span>
            </p>
          </div>
        </div>
      }
    </div>
  }
</div>
